define(function (require) {
	// templates
	const tpl = require('civicsViews/logs_view/templates/t_itv_log_item.hbs');

	return Marionette.ItemView.extend({
		initialize: function (options) {
			if (__DEV__) console.log('itv_log_item -- initialized');
		},
		onRender: function () {
			this.$el.rhythmThemeInitCivics();
			this.$el.rhythmThemeInit();
		},
		template: tpl,
		tagName: 'div',
		className: function () {
			return 'list-row';
		},
		attributes: {
			'role': 'row'
		}
	});
});
